import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { withI18nConsumer } from '@bingads-webui-react/i18n-context';
import { withInstrumentation } from '@bingads-webui-react/hoc-with-instrumentation';
import { withRecentReports } from '@bingads-webui-campaign/reports-v4-data-source';
import { ctrLoggerFactory } from '@bingads-webui-campaign/reports-v4-telemetry';
import { withReportsHistory } from '@bingads-webui-campaign/reports-v4-history';
import { withReportsV4SiteMap, withCustomReportsSiteMap } from '@bingads-webui-react/with-site-map';
import { buildReportTypeMapping, buildCustomReportTypeMapping } from '@bingads-webui-campaign/reports-v4-report-type-mapping';
import { withResponsiveMainMenu } from '@bingads-webui-campaign-react/main-menu';
import { withPreference } from '@bingads-webui-react/preference-context';
import { withRouter } from '@bingads-webui-campaign-react/router';
import { withPermissions } from '@bingads-webui-react/hoc-with-permissions';
import { isNavigationRefreshOn } from '@bingads-webui-react/preference-utility';
import { StyledReportsV4MainMenuView } from './ReportsV4MainMenuView';

const modePreferenceName = 'WebApp.CampaignUI.New.ReportsV4ManiMenuMode';

class ReportsV4MainMenuAdapter extends React.PureComponent {
  constructor(props) {
    super(props);

    const { instrumentation, permissions } = props;

    this.mainMenuScenario = instrumentation.createScenarioAndActivity({
      scenarioName: 'reportsV4MainMenuScenario',
      activityName: 'toggleMainMenuActivity',
    }).scenario;

    this.ctrLogger = ctrLoggerFactory('ReportsV4MainMenu', instrumentation);
    const isNavRefresh = isNavigationRefreshOn(permissions);
    if (isNavRefresh) {
      this.MainMenu = withRouter(withPreference(StyledReportsV4MainMenuView));
    } else {
      this.MainMenu = withRouter(withPreference(withResponsiveMainMenu(StyledReportsV4MainMenuView)));
    }
  }

  componentDidMount() {
    this.ctrLogger.impressionStart();
  }

  componentWillUnmount() {
    this.ctrLogger.impressionFinish();
  }

  onStaticItemClick = (node) => {
    const { reportsV4History } = this.props;

    reportsV4History.push(node.pathname);

    this.ctrLogger.click({
      target: node.logCategory,
    });
  };

  onDynamicItemClick = (node) => {
    const { reportsV4History } = this.props;

    reportsV4History.push(node.pathname);

    this.ctrLogger.click({
      target: node.logCategory,
      extraData: _.pick(node, 'Id', 'ReportType'),
    });
  };


  render() {
    const { siteMap, recentReports, permissions } = this.props;
    const isCustomReportBuilder = permissions && permissions.dynamic && permissions.dynamic.CustomReports;

    return (
      <React.Fragment>
        <this.MainMenu
          {...this.props}
          onStaticItemClick={this.onStaticItemClick}
          onDynamicItemClick={this.onDynamicItemClick}
          reports={recentReports ? recentReports.value : []}
          modePreferenceName={modePreferenceName}
          mainMenuScenario={this.mainMenuScenario}
          reportTypeMapping={isCustomReportBuilder ? buildCustomReportTypeMapping(siteMap) : buildReportTypeMapping(siteMap)}
        />
      </React.Fragment>
    );
  }
}

ReportsV4MainMenuAdapter.propTypes = {
  recentReports: PropTypes.shape({}),
  reportsV4History: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  instrumentation: PropTypes.shape({
    createScenarioAndActivity: PropTypes.func,
  }).isRequired,
  siteMap: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object,
  ]).isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({
      NavigationRefresh: PropTypes.bool,
    }),
  }).isRequired,
};

ReportsV4MainMenuAdapter.defaultProps = {
  recentReports: { value: [] },
};


export const ReportsV4MainMenu = _.compose(
  withI18nConsumer,
  withInstrumentation,
  withReportsV4SiteMap,
  withRecentReports,
  withReportsHistory,
  withPermissions
)(ReportsV4MainMenuAdapter);

export const CustomReportsMainMenu = _.compose(
  withI18nConsumer,
  withInstrumentation,
  withReportsV4SiteMap,
  withCustomReportsSiteMap,
  withRecentReports,
  withReportsHistory,
  withPermissions
)(ReportsV4MainMenuAdapter);
